// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#chip {\n  font-size: 15px !important;\n  border-left: 20px;\n  margin: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
